export const scope = 'containers.component.PLP.filters';

export const quickLinkMessages = {
  quickLinks: {
    id: `${scope}.quickLinks`,
    defaultMessage: 'Quick links',
  },
};
